import React from "react";
import { Switch } from "antd";

const ViewModeToggle = ({ isNewView, setIsNewView }) => {
  return (
    <div className="view-mode-toggle">
      <span className={!isNewView ? "active-mode" : ""}>Legacy</span>
      <Switch
        checked={isNewView}
        onChange={(checked) => setIsNewView(checked)}
        size="small"
        className="mode-switch"
      />
      <span className={isNewView ? "active-mode" : ""}>Modern</span>
    </div>
  );
};

export default ViewModeToggle;
